export default __webpack_public_path__ + "static/media/pass.750ab149.png";